<template>
  <div class="permits-loader-page">
    <div v-if="!componentView" class="permits-loading-state">
      <div class="loader-backdrop"></div>
      <div class="loader-card">
        <div class="loader-spinner-wrap">
          <div class="loader-spinner"></div>
        </div>
        <h3>Menyiapkan Halaman</h3>
        <p>Mohon tunggu, data sedang diproses...</p>

        <div class="loader-skeleton-list">
          <div class="skeleton-line line-1"></div>
          <div class="skeleton-line line-2"></div>
          <div class="skeleton-line line-3"></div>
        </div>
      </div>
    </div>
    <component :is="componentView" v-else/>
  </div>
</template>

<script>
import axios from "axios"

export default {
  data() {
    return {
      componentView: null
    }
  },
  async created() {
    try {
      const res = await axios.get(`${process.env.VUE_APP_PB_API}/ags/permit/version`)

      const version = res.data.version

      if (version === "v2") {
        this.componentView = () => import("../views/Permits.vue")
      } else {
        this.componentView = () => import("../views/PermitsV1.vue")
      }

    } catch (e) {
      console.error(e)

      // fallback
      this.componentView = () => import("../views/PermitsV1.vue")
    }
  }
}
</script>

<style scoped>
.permits-loader-page {
  min-height: 100vh;
}

.permits-loading-state {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: linear-gradient(135deg, #f3f7fb 0%, #e9f0f9 55%, #f8fbff 100%);
  position: relative;
  overflow: hidden;
}

.loader-backdrop {
  position: absolute;
  width: 380px;
  height: 380px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(32, 125, 190, 0.2) 0%, rgba(32, 125, 190, 0) 68%);
  top: -90px;
  right: -110px;
}

.loader-card {
  width: 100%;
  max-width: 440px;
  background: #ffffff;
  border: 1px solid #deebf7;
  border-radius: 18px;
  box-shadow: 0 14px 34px rgba(18, 52, 86, 0.12);
  padding: 28px 24px;
  text-align: center;
  position: relative;
  z-index: 1;
  animation: rise-in 0.45s ease-out;
}

.loader-spinner-wrap {
  display: flex;
  justify-content: center;
  margin-bottom: 14px;
}

.loader-spinner {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  border: 4px solid #d5e5f4;
  border-top-color: #207dbe;
  animation: spin 0.9s linear infinite;
}

.loader-card h3 {
  margin: 0 0 6px;
  color: #17446a;
  font-size: 22px;
  font-weight: 700;
}

.loader-card p {
  margin: 0;
  color: #52708e;
  font-size: 14px;
}

.loader-skeleton-list {
  margin-top: 24px;
  display: grid;
  gap: 10px;
}

.skeleton-line {
  height: 12px;
  border-radius: 999px;
  background: linear-gradient(90deg, #e6eef6 25%, #f3f8fd 45%, #e6eef6 65%);
  background-size: 220% 100%;
  animation: shimmer 1.3s linear infinite;
}

.line-1 {
  width: 82%;
  justify-self: center;
}

.line-2 {
  width: 66%;
  justify-self: center;
}

.line-3 {
  width: 74%;
  justify-self: center;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

@keyframes shimmer {
  0% {
    background-position: 180% 0;
  }
  100% {
    background-position: -40% 0;
  }
}

@keyframes rise-in {
  0% {
    opacity: 0;
    transform: translateY(12px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (max-width: 576px) {
  .permits-loading-state {
    padding: 16px;
  }

  .loader-card {
    padding: 22px 18px;
  }

  .loader-card h3 {
    font-size: 19px;
  }

  .loader-card p {
    font-size: 13px;
  }
}
</style>